<template>
  <list-dashboards titleSmartsheet="General" :typeSmartsheet="SMARTSHEET_TYPES.general">
  
  </list-dashboards>
</template>

<script>
import ListDashboards from '../../../components/smartsheet/ListDashboards.vue'
import { SMARTSHEET_TYPES } from '@/constants/smartsheet'

export default {
  components: { ListDashboards },
  data(){
    return {
      SMARTSHEET_TYPES
    }
  }
}
</script>

<style>

</style>